import { ActionsRecommendations } from './sections/ActionsRecommendations';
import { Details } from './sections/Details';
import { FireSafetySurvey } from './sections/FireSafetySurvey';
import { RiskToResidentPremises } from './sections/RiskToResidentPremises';
import { WhatToDoNext } from './sections/WhatToDoNext';
import { PcfraSection, PcfraSectionConfig } from './types';

export const pcfraConfig: Record<PcfraSection, PcfraSectionConfig> = {
  details: {
    title: 'Initial details',
    SectionForm: Details,
  },
  fireSafetySurvey: {
    title: 'Fire safety survey',
    SectionForm: FireSafetySurvey,
  },
  whatToDoNext: {
    title: 'What to do next',
    SectionForm: WhatToDoNext,
  },
  actionsRecommendations: {
    title: 'Actions & recommendations',
    SectionForm: ActionsRecommendations,
  },
  riskToResidentPremises: {
    title: 'Risk to resident/premises',
    SectionForm: RiskToResidentPremises,
  },
};

export const pcfraConfigEntries = Object.entries(pcfraConfig) as [
  PcfraSection,
  PcfraSectionConfig,
][];

export const pcfraSections = Object.keys(pcfraConfig) as PcfraSection[];
